import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';

interface ReorderDataHooks {
  dataHookFrom: string;
  dataHookTo: string;
}

interface NestableItemDetails {
  dataHook: string;
  depthLevel: number;
  threshold?: number;
}

export interface NestableListBaseDriver extends BaseDriver {
  reorder: (dataHooks: ReorderDataHooks) => void;
  changeItemDepth: (itemDetails: NestableItemDetails) => void;
  getItemPosition: (itemDetails: { dataHook: string }) => number;
  getItemDepth: (itemDetails: { dataHook: string }) => number;
}
